import Layout from '@/layout/index.vue';

export default [
  {
    path: '/appManage',
    redirect: '/appManage/formal',
  },
  {
    path: '/poManage/formal',
    component: Layout,
    name: 'poManage',
    meta: {
      title: 'PO管理',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/appManage/poManage/fault_list.vue'),
        meta: { title: 'PO确认单', icon: 'el-icon-s-management' },
      },
      {
        path: 'charging',
        name: 'charging',
        component: () => import('@/views/appManage/poManage/po_charging.vue'),
        meta: { title: 'PO计费单', icon: 'el-icon-s-management' },
      },
      {
        path: 'otherDocument',
        name: 'otherDocument',
        component: () => import('@/views/appManage/poManage/otherDocument.vue'),
        meta: { title: '其它单据', icon: 'el-icon-s-management' },
      },
      {
        path: 'efficiency',
        name: 'efficiency',
        component: () => import('@/views/appManage/poManage/po_aging.vue'),
        meta: { title: 'PO时效', icon: 'el-icon-s-management' },
      },
      {
        path: 'check',
        name: 'check',
        component: () => import('@/views/appManage/poManage/po_check.vue'),
        meta: { title: 'PO核对', icon: 'el-icon-s-management' },
      },
      {
        path: 'alignment',
        name: 'alignment',
        component: () => import('@/views/appManage/poManage/po_alignment.vue'),
        meta: { title: 'PO数据对齐', icon: 'el-icon-s-management' },
      },
      {
        path: 'assetBilling',
        name: 'assetBilling',
        component: () => import('@/views/appManage/poManage/asset_billing.vue'),
        meta: { title: '资产PO计费单', icon: 'el-icon-s-management' },
      },
      {
        path: 'assetConfirmation',
        name: 'assetConfirmation',
        component: () => import('@/views/appManage/poManage/asset_confirmation.vue'),
        meta: { title: '资产PO确认单', icon: 'el-icon-s-management' },
      },
    ],
  },

  {
    path: '/appManage/formal',
    component: Layout,
    name: 'appManage',
    meta: {
      title: '工单管理',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    redirect: '/poManage/formal/list',
    children: [
      {
        path: 'dcopsTicket',
        name: 'dcopsTicket',
        component: () => import('@/views/appManage/layout.vue'), // 添加布局组件
        // SidebarItem.vue 判断的是 item.alwaysShow（不在 meta 上），
        // 且当父级只有一个可见子路由时会默认只显示子级菜单；
        // 这里显式开启 alwaysShow，确保显示“DCOPS工单”父级菜单。
        alwaysShow: true,
        meta: { title: 'DCOPS工单', icon: 'el-icon-s-management' },
        children: [
          {
            path: 'serverMove',
            name: 'serverMove',
            component: () => import('@/views/workOrder/dcopsTicket/serverMove.vue'),
            meta: {
              title: '服务器搬迁',
              icon: 'el-icon-s-tools',
              alwaysShow: true, // 即使只有一个子路由也显示父级菜单
            },
          },
        ],
      },
      {
        path: 'server',
        name: 'server',
        component: () => import('@/views/appManage/layout.vue'), // 添加布局组件
        meta: { title: '服务器', icon: 'el-icon-s-management' },
        children: [
          {
            path: 'resourceDelivery',
            name: 'resourceDelivery',
            component: () => import('@/views/workOrder/server/delivery.vue'),
            meta: {
              title: '资源交付',
              icon: 'el-icon-s-platform',
            },
          },
          {
            path: 'faultDiagnosis',
            name: 'faultDiagnosis',
            component: () => import('@/views/workOrder/faultDiagnosis/index.vue'),
            meta: {
              title: '故障诊断',
              icon: 'el-icon-s-tools',
              alwaysShow: true, // 即使只有一个子路由也显示父级菜单
            },
          },
          {
            path: 'faultHandling',
            name: 'faultHandling',
            component: () => import('@/views/workOrder/faultHandling/index.vue'),
            meta: {
              title: '故障处理',
              icon: 'el-icon-s-tools',
              alwaysShow: true, // 即使只有一个子路由也显示父级菜单
            },
          },
          {
            path: 'PartObsolescence',
            name: 'PartObsolescence',
            component: () => import('@/views/workOrder/obsolescence/index.vue'),
            meta: {
              title: '部件利旧',
              icon: 'el-icon-s-tools',
              alwaysShow: true, // 即使只有一个子路由也显示父级菜单
            },
          },
          {
            path: 'rest',
            name: 'rest',
            component: () => import('@/views/workOrder/servesRests/index.vue'),
            meta: {
              title: '其他',
              icon: 'el-icon-s-tools',
              alwaysShow: true, // 即使只有一个子路由也显示父级菜单
            },
          },
        ],
      },

      {
        path: 'network',
        name: 'network',
        component: () => import('@/views/appManage/layout.vue'), // 添加布局组件
        meta: {
          title: '网络',
          icon: 'el-icon-s-grid',
          alwaysShow: true, // 即使只有一个子路由也显示父级菜单
        },
        children: [
          {
            path: 'networkAllTicket',
            name: 'networkAllTicket',
            component: () => import('@/views/workOrder/network/allNetworkTicketInfo.vue'),
            meta: { title: '网络总工单', icon: 'el-icon-s-management' },
          },
          {
            path: 'networkDiagnosis',
            name: 'networkDiagnosis',
            component: () => import('@/views/workOrder/network/diagnosis.vue'),
            meta: { title: '网络诊断', icon: 'el-icon-s-management' },
          },
          {
            path: 'networkChange',
            name: 'networkChange',
            component: () => import('@/views/workOrder/network/change.vue'),
            meta: { title: '网络变更', icon: 'el-icon-s-order' },
          },
          {
            path: 'soldDismantle',
            name: 'soldDismantle',
            component: () => import('@/views/workOrder/network/soldDismantle.vue'),
            meta: { title: '下架与拆解', icon: 'el-icon-s-order' },
          },
          {
            path: 'moduleOperations',
            name: 'moduleOperations',
            component: () => import('@/views/workOrder/network/moduleOperations.vue'),
            meta: { title: '端口操作', icon: 'el-icon-s-order' },
          },
          {
            path: 'ODFOperations',
            name: 'ODFOperations',
            component: () => import('@/views/workOrder/network/ODFOperations.vue'),
            meta: { title: '链路操作', icon: 'el-icon-s-order' },
          },
          {
            path: 'equipmentOperation',
            name: 'equipmentOperation',
            component: () => import('@/views/workOrder/network/equipmentOperation.vue'),
            meta: { title: '设备操作', icon: 'el-icon-s-order' },
          },
        ],
      },
      {
        path: 'asset',
        name: 'asset',
        meta: { title: '资产', icon: 'el-icon-s-management' },
        component: () => import('@/views/appManage/layout.vue'), // 添加布局组件
        children: [
          {
            path: 'stock',
            name: 'stock',
            component: () => import('@/views/workOrder/asset/assetStock.vue'),
            meta: { title: '出库', icon: 'el-icon-s-management' },
          },
          {
            path: 'storage',
            name: 'storage',
            component: () => import('@/views/workOrder/asset/storage.vue'),
            meta: { title: '入库', icon: 'el-icon-s-order' },
          },
        ],
      },

      {
        path: 'other',
        name: 'other',
        meta: { title: '其它', icon: 'el-icon-s-management' },
        alwaysShow: true, // 即使只有一个子路由也显示父级菜单
        component: () => import('@/views/appManage/layout.vue'), // 添加布局组件
        children: [
          {
            path: 'idcSupport',
            name: 'idcSupport',
            component: () => import('@/views/workOrder/other/idcSupport.vue'),
            meta: { title: 'IDC支持', icon: 'el-icon-s-management' },
          },
          {
            path: 'AdHoc',
            name: 'AdHoc',
            component: () => import('@/views/workOrder/other/AdHoc.vue'),
            meta: { title: '按次专项', icon: 'el-icon-s-management' },
          },
        ],
      },
      {
        path: 'personal',
        name: 'personal',
        meta: { title: '人力', icon: 'el-icon-s-management' },
        component: () => import('@/views/appManage/layout.vue'), // 添加布局组件
        children: [
          {
            path: 'FixedHC',
            name: 'FixedHC',
            component: () => import('@/views/workOrder/personal/FixedHC.vue'),
            //服务器故障工单
            meta: { title: '固定HC', icon: 'el-icon-s-management' },
          },
          {
            path: 'HongyunSpecial',
            name: 'HongyunSpecial',
            component: () => import('@/views/workOrder/personal/HongyunSpecial.vue'),
            meta: { title: '鸿云专项', icon: 'el-icon-s-order' },
          },
          {
            path: 'OutsourcingResources',
            name: 'OutsourcingResources',
            component: () => import('@/views/workOrder/personal/OutsourcingResources.vue'),
            meta: { title: '外包资源', icon: 'el-icon-s-order' },
          },
        ],
      },
    ],
  },

  {
    path: '/billManage/formal',
    component: Layout,
    name: 'billManage',
    meta: {
      title: '账单管理',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'billList',
        name: 'billManageList',
        component: () => import('@/views/billManage/billList/index.vue'),
        meta: { title: '账单列表', icon: 'el-icon-s-management' },
      },
      {
        path: 'billCHeck',
        name: 'billCHeck',
        component: () => import('@/views/billManage/billCHeck/index.vue'),
        meta: { title: '账单核对', icon: 'el-icon-s-management' },
      },
      {
        path: 'resident',
        name: 'resident',
        component: () => import('@/views/billManage/resident/index.vue'),
        meta: { title: '驻场人力', icon: 'el-icon-s-management' },
      },
      {
        path: 'special',
        name: 'special',
        component: () => import('@/views/billManage/special/index.vue'),
        meta: { title: '专项服务', icon: 'el-icon-s-management' },
      },
    ],
  },

  {
    path: '/auditManage/formal',
    component: Layout,
    name: 'orderAudit',
    meta: {
      title: '工单审计',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'handTodo',
        name: 'handTodo',
        component: () => import('@/views/orderAudit/handTodo.vue'),
        meta: { title: '我的待审', icon: 'el-icon-s-management' },
      },
      {
        path: 'finished',
        name: 'finished',
        component: () => import('@/views/orderAudit/finished.vue'),
        meta: { title: '我的已审', icon: 'el-icon-s-management' },
      },
      {
        path: 'auditList',
        name: 'auditManageList',
        component: () => import('@/views/orderAudit/auditList.vue'),
        meta: { title: '审计列表', icon: 'el-icon-s-management' },
      },
    ],
  },

  {
    path: '/staffManage/formal',
    component: Layout,
    name: 'staffManage',
    meta: {
      title: '人员管理',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'resourceAdmin',
        name: 'resourceAdmin',
        component: () => import('@/views/staffManage/resource/index.vue'),
        meta: { title: '资源管理', icon: 'el-icon-s-management' },
      },
      {
        path: 'salary',
        name: 'salary',
        component: () => import('@/views/personnel/salary.vue'),
        meta: { title: '考勤管理', icon: 'el-icon-s-management' },
      },
      {
        path: 'connect',
        name: 'connect',
        component: () => import('@/views/personnel/connect.vue'),
        meta: { title: '交接管理', icon: 'el-icon-s-management' },
      },
      {
        path: 'onBusiness',
        name: 'onBusiness',
        component: () => import('@/views/personnel/onBusiness.vue'),
        meta: { title: '出差管理', icon: 'el-icon-s-management' },
      },

      {
        path: 'training',
        name: 'training',
        component: () => import('@/views/personnel/training.vue'),
        meta: { title: '技能培训', icon: 'el-icon-s-management' },
      },
    ],
  },
];
